/**
 * ICENFIRE FX — Silent Luxury
 * Whisper reveals only. No cursor, magnets, or heat maps.
 */
(() => {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let io;

  function bindEnter(root = document) {
    const nodes = root.querySelectorAll('[data-enter]:not(.is-in)');
    if (!nodes.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      nodes.forEach((n) => n.classList.add('is-in'));
      return;
    }

    if (!io) {
      io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        },
        { threshold: 0.12, rootMargin: '0px 0px -4% 0px' }
      );
    }

    nodes.forEach((n) => {
      const r = n.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) {
        requestAnimationFrame(() => n.classList.add('is-in'));
      } else {
        io.observe(n);
      }
    });
  }

  function sync() {
    bindEnter();
  }

  function boot() {
    bindEnter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('icenfire:themechange', bindEnter);

  window.IcenfireFX = { sync, bindEnter, collectMagnets: () => {} };
})();
